// start:ng42.barrel
export * from './abmroles-filter.component';
// end:ng42.barrel




// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/abm/abmroles-filter/index.ts